// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.roomContainer {
  display: flex;
  flex-direction: column;
  min-height: 100%;
}

@media (max-width: 600px) {
  .roomContainer {
    min-height: 100vh;
    min-height: 100dvh;
  }
}

/* A single-cell grid: the team panels and the all-play overlay share the
   cell, so the card grows to fit whichever is taller instead of clipping
   the overlay. */
.roomContent {
  display: grid;
  grid-template-columns: minmax(0, 1fr);
  position: relative;
  flex-grow: 1;
  min-height: var(--content-height);
}

.roomContent > * {
  grid-column: 1;
  grid-row: 1;
}

.teamPanels {
  display: flex;
  min-width: 0;
}

@media (max-width: 600px) {
  .roomContent {
    min-height: unset;
  }
}

/* ---- Shared move layout (host panels and player phone) ---- */

.movePanel {
  width: 100%;
  box-sizing: border-box;
  padding: 1.25rem 1.5rem 1rem;
  display: flex;
  flex-direction: column;
  text-align: center;
}

/* Status pill row; the ring timer floats at the right edge. */
.moveTop {
  position: relative;
  display: flex;
  justify-content: center;
  align-items: center;
  min-height: 3rem;
  margin: 0 0 0.75rem;
}

.moveTop .timer {
  position: absolute;
  right: 0;
  top: 50%;
  margin-top: calc(var(--timer-size) / -2);
}

.moveKicker {
  font-family: var(--font-body);
  font-weight: 700;
  font-size: 1.15rem;
  color: var(--ink);
  margin: 0.4rem 0 0;
  text-align: center;
}

.moveQuestion {
  font-family: var(--font-heading);
  font-weight: 600;
  font-size: 2.6rem;
  line-height: 1.1;
  margin: 0.15rem 0 1.25rem;
  text-align: center;
  overflow-wrap: anywhere;
}

/* Whose turn — the visual center of Read the Room / Fact or Fib. */
.moveTurn {
  font-family: var(--font-heading);
  font-weight: 600;
  font-size: 2.4rem;
  line-height: 1.05;
  margin: 0 0 0.35rem;
  text-align: center;
  overflow-wrap: anywhere;
}

.moveTurn.team1 {
  color: var(--team1-text);
}

.moveTurn.team2 {
  color: var(--team2-text);
}

.moveFooter {
  margin: 1rem 0 0;
  font-size: 0.95rem;
  font-weight: 700;
  color: var(--ink-soft);
  text-align: center;
}

.formHint {
  color: var(--ink-soft);
  font-size: 0.95rem;
  margin: -0.5rem 0 0.75rem;
}

.formActions {
  display: flex;
  justify-content: flex-end;
  gap: 0.5rem;
  margin-top: 0.5rem;
}

.formActions button {
  margin: 0;
}

.formActions .back {
  margin-right: auto;
}

/* ---- Player phone ---- */

.playerRoom {
  padding: 1rem 1.25rem 1.5rem;
  width: 100%;
  box-sizing: border-box;
  background-color: var(--sky-soft);
  transition: background-color 0.6s linear;
  text-align: center;
}

.playerRoom .movePanel {
  padding: 0;
}

.playerRoom .moveTop {
  justify-content: flex-start;
  min-height: 4.5rem;
  margin-bottom: 0.5rem;
}

.playerRoom .moveTop .statusPill {
  font-size: 1.1rem;
  white-space: normal;
  text-align: center;
}

/* Leave room for the timer next to the pill. */
.playerRoom .moveTop:has(.timer) {
  padding-right: 5.25rem;
}

.playerRoom .moveKicker,
.playerRoom .moveQuestion,
.playerRoom .formHint {
  text-align: left;
}

.playerRoom .moveQuestion {
  font-size: 2.2rem;
  margin-bottom: 1rem;
}

.playerRoom.team1 {
  background-color: var(--sky);
}

.playerRoom.team2 {
  background-color: var(--pink-soft);
}

.playerRoom textarea {
  display: block;
  box-sizing: border-box;
  width: 100%;
  min-width: unset;
  text-align: left;
}

.playerRoom input[type="text"] {
  display: block;
  width: 100%;
  min-width: unset;
  margin: 0.25rem 0 0.75rem;
  text-align: center;
  font-family: var(--font-heading);
  font-weight: 600;
  font-size: 1.4rem;
}

.playerRoom .moveFooter {
  margin-top: 0.9rem;
}

.playerRoom .teamList {
  margin-top: 0.75rem;
}

.playerRoom .teamListItem {
  background: var(--white);
  box-shadow: var(--shadow-card);
}

.gameRecap .moveKicker {
  text-align: center;
}

.recapScore {
  font-family: var(--font-heading);
  font-weight: 600;
  font-size: 3rem;
  line-height: 1.05;
  margin: 0.35rem 0 0.6rem;
}

.recapMoment {
  font-size: 1.15rem;
  font-weight: 700;
  margin: 0 0 1rem;
}

.recapPoster {
  display: block;
  width: 100%;
  max-width: 14rem;
  margin: 0 auto 0.25rem;
  border-radius: 12px;
  box-shadow: var(--shadow-card);
}

.waitingRoom {
  text-align: center;
  padding-top: 0.5rem;
}

.waitingRoom .moveTop {
  justify-content: center;
}

.waitingRoom .moveQuestion {
  text-align: center;
  margin-top: 1.5rem;
}

.waitingRoom button {
  margin-top: 1.5rem;
}

.nameForm {
  text-align: left;
}

.charCount {
  text-align: right;
  margin: 0 0 0.6rem;
  font-weight: 700;
  font-size: 0.9rem;
  color: var(--ink-soft);
}

/* Slider (Group Think) on the phone. */
.sliderCard {
  background: var(--white);
  border-radius: var(--border-radius);
  box-shadow: var(--shadow-card);
  padding: 1rem 1.25rem 1.25rem;
}

.sliderValue {
  font-family: var(--font-heading);
  font-weight: 600;
  font-size: 2.4rem;
  line-height: 1.1;
  color: var(--ink);
  margin: 0 0 0.5rem;
}

.sliderCard .rc-slider {
  width: unset;
  margin: 1rem 0.75rem 0.25rem;
  height: 2.5rem;
  padding: 0.8rem 0;
}

.sliderCard .rc-slider-rail {
  height: 0.9rem;
  background-color: #dbe7f5;
  border-radius: 999px;
}

.sliderCard .rc-slider-track {
  height: 0.9rem;
  background-color: var(--navy);
  border-radius: 999px;
}

.sliderCard .rc-slider-handle {
  height: 2.2rem;
  width: 2.2rem;
  margin-top: -0.65rem;
  opacity: 1;
  border: 3px solid var(--white);
  background-color: var(--navy);
  box-shadow: 0 2px 6px rgba(14, 36, 99, 0.35);
}

.sliderCard .rc-slider-handle:hover,
.sliderCard .rc-slider-handle:active,
.sliderCard .rc-slider-handle:focus-visible,
.sliderCard .rc-slider-handle-dragging.rc-slider-handle-dragging.rc-slider-handle-dragging {
  border-color: var(--white);
  box-shadow: 0 0 0 4px rgba(23, 53, 127, 0.25);
}

/* ---- Host lobby ---- */

.lobby {
  position: relative;
  width: 100%;
  box-sizing: border-box;
  padding: 1.5rem 2rem 2rem;
  display: flex;
  flex-direction: column;
  overflow: hidden;
}

.lobby > * {
  position: relative;
  z-index: 1;
}

/* Arriving from the landing page through the split wipe: the lobby rises
   into place as the ice breaks open. */
.roomContainer.entering .lobbyTitle {
  animation: landIn 0.6s var(--bounce-effect) 0.45s both;
}

.roomContainer.entering .joinPanel {
  animation: landIn 0.65s var(--bounce-effect) 0.55s both;
}

.roomContainer.entering .playersPanel {
  animation: landIn 0.65s var(--bounce-effect) 0.65s both;
}

.lobbyTitle {
  text-align: center;
  margin-bottom: 1.25rem;
}

.lobbyTitle h1 {
  font-size: 3rem;
  margin: 0;
}

.lobbyTitle p {
  margin: 0.2rem 0 0;
  font-size: 1.1rem;
  font-weight: 700;
  color: var(--ink);
}

.lobbyBody {
  display: flex;
  gap: 1.5rem;
  align-items: stretch;
  flex: 1;
}

/* ---- Lobby: everybody's in ---- */

/* Same pink/blue wash and sparkle field as the landing page. */
.lobby.allReady {
  background:
    radial-gradient(ellipse 55% 42% at 12% -8%, rgba(240, 110, 163, 0.22), transparent 70%),
    radial-gradient(ellipse 50% 40% at 92% 0%, rgba(56, 182, 245, 0.28), transparent 68%);
}

.lobby > .lobbyDecor {
  position: absolute;
  z-index: 0;
  animation: fadeIn 0.8s ease-out both;
}

.lobbyDecor .spark.s1 { top: 4%; left: 4%; animation-delay: 0s; background: var(--pink); }
.lobbyDecor .spark.s2 { top: 7%; right: 5%; width: 0.8rem; height: 0.8rem; animation-delay: 0.4s; background: var(--blue); }
.lobbyDecor .spark.s3 { top: 16%; left: 24%; width: 0.7rem; height: 0.7rem; animation-delay: 0.9s; }
.lobbyDecor .spark.s4 { top: 14%; right: 26%; animation-delay: 1.3s; background: var(--pink); }
.lobbyDecor .spark.s5 { bottom: 14%; left: 5%; width: 0.65rem; height: 0.65rem; animation-delay: 0.6s; background: var(--blue); }
.lobbyDecor .spark.s6 { bottom: 6%; left: 20%; width: 0.85rem; height: 0.85rem; animation-delay: 1.6s; }

.lobbyDecor .flake.f1 { top: 9%; left: 29%; background: var(--pink-soft); animation-delay: 0.2s; }
.lobbyDecor .flake.f2 { top: 5%; right: 32%; animation-delay: 1.1s; }
.lobbyDecor .flake.f3 { top: 58%; left: 8%; background: var(--blue); animation-delay: 2s; }
.lobbyDecor .flake.f4 { bottom: 22%; left: 24%; background: var(--pink); animation-delay: 2.8s; }

.lobby.allReady .lobbyTitle h1 {
  animation: titlePop 0.7s var(--bounce-effect) both;
}

.lobby.allReady .lobbyTitle h1::before,
.lobby.allReady .lobbyTitle h1::after {
  border-color: var(--pink);
  animation: chevronNudge 1.6s ease-in-out infinite;
}

.lobby.allReady .lobbyTitle h1::after {
  animation-name: chevronNudgeReverse;
}

.lobby.allReady .lobbyTitle p {
  animation: landIn 0.6s var(--bounce-effect) 0.1s both;
}

/* Ready count pill turns into the pink→blue gradient. */
.lobby.allReady .playersHeading .pill {
  background: linear-gradient(90deg, var(--pink), var(--blue));
  color: var(--white);
  animation: landIn 0.5s var(--bounce-effect) both;
}

/* Rows cheer in order, and each check pops. */
.lobby.allReady .playerRow.ready {
  animation: rowCheer 0.6s var(--bounce-effect) calc(var(--i, 0) * 70ms) both;
}

.lobby.allReady .playerRow.ready .readyCheck {
  background: var(--pink);
  animation: checkPop 0.5s var(--bounce-effect) calc(var(--i, 0) * 70ms + 0.2s) both;
}

.lobby.allReady .playerRow.ready .readyCheck::after {
  border-color: var(--white);
}

.lobby.allReady .waitingText {
  margin-top: 1.1rem;
}

.readyBanner {
  display: inline-flex;
  align-items: center;
  gap: 0.6rem;
  padding: 0.5rem 1.4rem;
  border-radius: var(--pill-radius);
  background: linear-gradient(90deg, var(--pink), var(--blue));
  color: var(--white);
  font-family: var(--font-heading);
  font-weight: 600;
  font-size: 1.15rem;
  line-height: 1.2;
  box-shadow: 0 6px 16px rgba(240, 110, 163, 0.28);
  animation:
    landIn 0.6s var(--bounce-effect) 0.3s both,
    bannerGlow 2.4s ease-in-out 0.9s infinite;
}

.readyBanner::before,
.readyBanner::after {
  content: "";
  width: 0.7rem;
  height: 0.7rem;
  background: var(--white);
  clip-path: polygon(50% 0, 62% 38%, 100% 50%, 62% 62%, 50% 100%, 38% 62%, 0 50%, 38% 38%);
  animation: twinkle 1.8s ease-in-out infinite;
}

.readyBanner::after {
  animation-delay: 0.9s;
}

/* Start game gets the sweep and a soft heartbeat. */
.lobby.allReady .lobbyActions .startGame:not(:disabled) {
  animation: startPulse 2s ease-in-out 0.6s infinite;
}

@keyframes fadeIn {
  from { opacity: 0; }
  to { opacity: 1; }
}

@keyframes titlePop {
  0% { transform: scale(0.9); opacity: 0.4; }
  55% { transform: scale(1.06); opacity: 1; }
  100% { transform: scale(1); opacity: 1; }
}

@keyframes chevronNudge {
  0%, 100% { transform: rotate(45deg) translate(0, 0); }
  50% { transform: rotate(45deg) translate(3px, 3px); }
}

@keyframes chevronNudgeReverse {
  0%, 100% { transform: rotate(-135deg) translate(0, 0); }
  50% { transform: rotate(-135deg) translate(3px, 3px); }
}

@keyframes rowCheer {
  0% { transform: translateX(0) scale(1); }
  35% { transform: translateX(6px) scale(1.02); }
  70% { transform: translateX(-2px) scale(1.01); }
  100% { transform: translateX(0) scale(1); }
}

@keyframes checkPop {
  0% { transform: scale(1); }
  45% { transform: scale(1.45) rotate(8deg); }
  100% { transform: scale(1) rotate(0deg); }
}

@keyframes bannerGlow {
  0%, 100% { box-shadow: 0 6px 16px rgba(240, 110, 163, 0.28); }
  50% { box-shadow: 0 6px 22px rgba(56, 182, 245, 0.5); }
}

@keyframes startPulse {
  0%, 100% {
    box-shadow: 0 3px 0 var(--navy-deep), 0 0 0 0 rgba(56, 182, 245, 0.55);
  }
  50% {
    box-shadow: 0 3px 0 var(--navy-deep), 0 0 0 10px rgba(56, 182, 245, 0);
  }
}

@media (prefers-reduced-motion: reduce) {
  .roomContainer.entering .lobbyTitle,
  .roomContainer.entering .joinPanel,
  .roomContainer.entering .playersPanel,
  .lobby > .lobbyDecor,
  .lobby.allReady .lobbyTitle h1,
  .lobby.allReady .lobbyTitle h1::before,
  .lobby.allReady .lobbyTitle h1::after,
  .lobby.allReady .lobbyTitle p,
  .lobby.allReady .playersHeading .pill,
  .lobby.allReady .playerRow.ready,
  .lobby.allReady .playerRow.ready .readyCheck,
  .readyBanner,
  .readyBanner::before,
  .readyBanner::after,
  .lobby.allReady .lobbyActions .startGame:not(:disabled) {
    animation: none;
  }
}

.joinPanel {
  flex: 0 0 18rem;
  background: var(--white);
  border-radius: var(--card-radius);
  box-shadow: var(--shadow-card);
  padding: 1.25rem 1.25rem 1.5rem;
  text-align: center;
  display: flex;
  flex-direction: column;
  align-items: center;
  align-self: flex-start;
  box-sizing: border-box;
}

.joinPanel h2 {
  margin: 0 0 0.75rem;
  font-size: 1.7rem;
}

.qr {
  display: block;
  width: 12rem;
  height: 12rem;
  border-radius: 8px;
  box-sizing: border-box;
}

span.qr {
  background: var(--sky-soft);
}

.joinLabel {
  margin: 1rem 0 0.4rem;
  font-weight: 700;
  font-size: 0.95rem;
}

.roomCodeBig {
  background: var(--sky);
  color: var(--ink);
  border-radius: 12px;
  padding: 0.35rem 1.5rem;
  min-width: 5rem;
  box-sizing: border-box;
  font-family: var(--font-heading);
  font-weight: 600;
  font-size: 2.8rem;
  line-height: 1.15;
  letter-spacing: 0.1em;
  text-transform: uppercase;
}

.joinHint {
  margin: 0.75rem 0 0;
  font-size: 0.85rem;
  color: var(--ink-soft);
}

.playersPanel {
  flex: 1;
  min-width: 0;
  display: flex;
  flex-direction: column;
}

.playersHeading {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 1rem;
  margin-bottom: 0.6rem;
}

.playersHeading h2 {
  margin: 0;
  font-size: 1.7rem;
}

.playerList {
  display: flex;
  flex-direction: column;
  gap: 0.55rem;
  min-height: 6rem;
}

.playerRow {
  display: flex;
  align-items: center;
  gap: 0.8rem;
  background: var(--white);
  border-radius: var(--border-radius);
  box-shadow: var(--shadow-card);
  padding: 0.55rem 0.9rem;
  transition: opacity 0.15s linear;
}

.playerRow.loading {
  opacity: 0.4;
}

.playerRow.inactive {
  opacity: 0.55;
}

.playerRowMain {
  flex: 1;
  min-width: 0;
  display: flex;
  flex-direction: column;
  gap: 0.35rem;
}

.playerRowTop {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 0.75rem;
}

.playerName {
  font-family: var(--font-heading);
  font-weight: 600;
  font-size: 1.2rem;
  line-height: 1.2;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.playerStatus {
  flex-shrink: 0;
  display: inline-flex;
  align-items: center;
  gap: 0.4rem;
  font-size: 0.95rem;
  font-weight: 700;
  color: var(--ink);
}

.readyCheck {
  width: 1.3rem;
  height: 1.3rem;
  border-radius: 50%;
  background: var(--navy);
  position: relative;
}

.readyCheck::after {
  content: "";
  position: absolute;
  left: 0.42rem;
  top: 0.2rem;
  width: 0.3rem;
  height: 0.6rem;
  border-right: 2.5px solid var(--white);
  border-bottom: 2.5px solid var(--white);
  transform: rotate(45deg);
}

.progressContainer {
  height: 0.55rem;
  border-radius: 999px;
  background: #e3ebf7;
  overflow: hidden;
}

.progressIndicator {
  height: 100%;
  border-radius: 999px;
  transition: width 0.5s ease-in-out;
  background-color: var(--blue);
}

.playerRow.pink .progressIndicator {
  background-color: var(--pink);
}

.kickPlayer {
  flex-shrink: 0;
  display: grid;
  place-items: center;
  height: 1.6rem;
  width: 1.6rem;
  border-radius: 50%;
  color: var(--ink-soft);
  background: transparent;
  font-size: 1.1rem;
  line-height: 1;
  cursor: pointer;
  box-sizing: border-box;
  transition: background-color 0.12s linear, color 0.12s linear;
}

.kickPlayer:hover {
  background: #fde3ec;
  color: var(--error-color);
}

.waitingText {
  margin: 0.9rem 0 0.25rem;
  text-align: center;
  font-size: 0.95rem;
  font-weight: 700;
  color: var(--ink-soft);
}

.roundTypeStart {
  margin-top: auto;
  background: var(--paper);
  border-radius: var(--border-radius);
  padding: 0.75rem 1rem;
}

.lobbyActions {
  display: flex;
  justify-content: space-between;
  gap: 0.75rem;
  margin-top: 1rem;
}

.lobbyActions button {
  margin: 0;
}

.lobbyActions button:last-child {
  flex: 1;
  max-width: 20rem;
}

@media (max-width: 720px) {
  .lobby {
    padding: 1.25rem 1rem 1.5rem;
  }

  .lobbyTitle h1 {
    font-size: 2.2rem;
  }

  .lobbyBody {
    flex-direction: column;
  }

  .joinPanel {
    flex-basis: auto;
    align-self: stretch;
  }
}

/* ---- Host game: team panels ---- */

.leftTeamContainer,
.rightTeamContainer {
  --panel-pad-x: 1.25rem;
  position: relative;
  text-align: center;
  flex: 0 1 50%;
  padding: 1.25rem var(--panel-pad-x) 1.5rem;
  box-sizing: border-box;
  transition: flex 0.2s linear, padding 0.2s linear, background-color 0.3s linear;
  overflow: hidden;
  display: flex;
  flex-direction: column;
  align-items: stretch;
  min-width: 0;
}

.leftTeamContainer.full,
.rightTeamContainer.full {
  flex: 1 0 100%;
}

/* The idle panel collapses completely (padding included) so the active one
   really spans the whole room. */
.leftTeamContainer.full + .rightTeamContainer,
.leftTeamContainer:has(+ .rightTeamContainer.full) {
  flex: 0 0 0;
  padding-left: 0;
  padding-right: 0;
}

/* Lay the active panel's content out at its final, full-room width right
   away, so it is revealed by the slide rather than stretched with it.
   Only size in-flow panel content — marquees overlay the room and must
   not inherit this width. */
.leftTeamContainer.full > .movePanel,
.leftTeamContainer.full > .allPlay,
.rightTeamContainer.full > .movePanel,
.rightTeamContainer.full > .allPlay {
  width: calc(var(--room-width) - 2 * var(--panel-pad-x));
  flex-shrink: 0;
}

/* The right panel grows leftward, so pin its content to the right edge
   (its resting place) and let the wipe uncover it. */
.rightTeamContainer.full > .movePanel,
.rightTeamContainer.full > .allPlay {
  align-self: flex-end;
}

.leftTeamContainer {
  background-color: var(--team1-panel);
}

.rightTeamContainer {
  background-color: var(--team2-panel);
}

.leftTeamContainer .movePanel,
.rightTeamContainer .movePanel {
  padding: 0;
}

/* Big-screen sizing for the question and answer cards. */
.leftTeamContainer .moveKicker,
.rightTeamContainer .moveKicker {
  font-size: 1.3rem;
}

.leftTeamContainer .moveTurn,
.rightTeamContainer .moveTurn {
  font-size: 5rem;
  margin: 0.1rem 0 0.55rem;
}

.leftTeamContainer .moveQuestion,
.rightTeamContainer .moveQuestion {
  font-size: 3rem;
}

.leftTeamContainer .movePanel .radiobtn label,
.rightTeamContainer .movePanel .radiobtn label {
  font-size: 1.35rem;
  min-height: 4.3rem;
  padding: 0.7rem 0.9rem;
}

.leftTeamContainer .movePanel .optionBadge,
.rightTeamContainer .movePanel .optionBadge {
  width: 2.9rem;
  height: 2.9rem;
  font-size: 1.6rem;
}

.leftTeamContainer .moveFooter,
.rightTeamContainer .moveFooter {
  font-size: 1.05rem;
  margin-top: 1.25rem;
}

.sideBetTally {
  font-family: var(--font-heading);
  font-weight: 600;
  font-size: 1.15rem;
  text-align: center;
  margin: 0.85rem 0 0;
  color: var(--ink-soft);
}

.sideBetChoices {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 0.75rem;
  margin-top: 0.5rem;
}

.sideBetChoices button {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 0.25rem;
  min-height: 6rem;
  font-size: 1.6rem;
  line-height: 1.05;
  margin: 0;
  padding: 0.7rem 0.55rem;
}

.sideBetChoices .sideBetCaption {
  display: block;
  font-family: var(--font-body);
  font-size: 0.8rem;
  font-weight: 800;
  letter-spacing: 0;
  line-height: 1.25;
  opacity: 0.8;
  max-width: 12em;
}

.sideBetChoices button.chosen {
  background: var(--navy);
  color: var(--white);
}

.playerRoom .sideBetStakes {
  color: var(--ink);
  margin-top: 0.85rem;
}

.playerRoom .sideBetHint {
  margin: 0.3rem 0 0;
  font-size: 0.9rem;
  font-weight: 700;
  color: var(--ink-soft);
  text-align: center;
}

/* Timer rides in the top-right corner of the active panel. */
.leftTeamContainer > .timer,
.rightTeamContainer > .timer {
  position: absolute;
  top: 1rem;
  right: 1.25rem;
  z-index: 2;
}

.teamTitle {
  font-size: 1.9rem;
  margin: 0.25rem 0 1rem;
}

.scoreDivider {
  margin: auto 1rem 0.75rem;
  align-self: stretch;
  opacity: 0.25;
}

.scoreContainer {
  font-family: var(--font-heading);
  font-weight: 600;
  font-size: 2.6rem;
  line-height: 1.1;
  margin: 0 0 0.25rem;
}

/* ---- Host game: all-play (Group Think / Drawn Together) ---- */

.allPlay {
  margin-top: 19rem;
  text-align: center;
}

.allPlay .teamTitle {
  margin-bottom: 0.75rem;
}

.allPlay .optionList {
  gap: 0.5rem;
}

.allPlay .radiobtn label {
  min-height: 3.2rem;
  padding: 0.45rem 0.7rem;
}

.allPlayOverlay {
  /* Sits in the same grid cell as the team panels, so it stacks on top of
     them while still contributing its height to the card. */
  position: relative;
  align-self: start;
  justify-self: center;
  margin: 1.25rem 0 1.5rem;
  padding: 1.25rem 1.5rem 1.5rem;
  text-align: center;
  width: 88%;
  background-color: var(--white);
  border-radius: var(--card-radius);
  box-shadow: 0 10px 30px rgba(14, 36, 99, 0.25);
  box-sizing: border-box;
  z-index: 3;
  animation: overlaySlideIn 0.55s var(--bounce-effect) both;
}

/* Drawn Together has no underlay player lists, so sit the card in the
   middle of the split instead of leaving a big empty band below it. */
.allPlayOverlay.drawnTogether {
  align-self: center;
}

/* Waiting view: fill the split and spread the prompt / player list apart. */
.allPlayOverlay.drawnTogether:has(.drawerStatusList) {
  min-height: calc(var(--content-height) - 4rem);
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  gap: 1.35rem;
  padding: 2.75rem 2.5rem 2.5rem;
}

.allPlayOverlay.drawnTogether:has(.drawerStatusList) .moveTop,
.allPlayOverlay.drawnTogether:has(.drawerStatusList) .moveHeading,
.allPlayOverlay.drawnTogether:has(.drawerStatusList) .drawerStatusList,
.allPlayOverlay.drawnTogether:has(.drawerStatusList) .moveFooter {
  margin: 0;
}

.allPlayOverlay.drawnTogether:has(.drawerStatusList) .moveKicker {
  margin: 0;
}

.allPlayOverlay.drawnTogether:has(.drawerStatusList) .moveQuestion {
  margin: 0.7rem 0 0;
}

@keyframes overlaySlideIn {
  from {
    opacity: 0;
    transform: translateY(-45%);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

.allPlayOverlay .moveQuestion {
  margin-bottom: 0.5rem;
}

.allPlayOverlay > .timer {
  position: absolute;
  top: 1rem;
  right: 1.25rem;
  z-index: 2;
}

/* ---- Marquee content: summaries (pie lives in shared/pie.css, team picking in marquees/team-picker.css) ---- */

.promptSummary {
  color: var(--ink);
  font-size: 1.5rem;
  margin-bottom: 1.5rem;
}

.teamSummary {
  display: flex;
  margin-bottom: 1rem;
  gap: 0.75rem;
}

.answerSummary {
  color: var(--ink);
  font-size: 3rem;
}

.actualAnswer {
  color: var(--ink);
  font-size: 6rem;
  padding: 1rem 1rem 0;
}

.endMoveSummary {
  flex: 1 1 50%;
  font-size: 1.5rem;
  color: var(--ink);
  padding: 0.75rem 1rem;
  border-radius: var(--border-radius);
  min-width: 0;
}

.endMoveSummary.team1 {
  background-color: var(--team1-panel);
}

.endMoveSummary.team2 {
  background-color: var(--team2-panel);
}

.endMoveSummary h3,
.endMoveSummary p {
  margin: 0 0 0.5rem;
  font-size: 1.6rem;
}

.summaryRow {
  display: flex;
  margin: 0.4rem 0;
  font-size: 1.5rem;
  font-family: var(--font-body);
}

.summaryRow > span {
  height: 2rem;
  line-height: 2rem;
}

.summaryRow :first-child {
  flex: 1 1 70%;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  padding: 0 0.4rem;
  text-align: left;
  font-family: var(--font-heading);
  font-weight: 600;
}

.summaryRow :last-child {
  flex: 0 0 30%;
}

.congratsSummary {
  text-align: center;
  display: flex;
  align-items: center;
  font-size: 2.6rem;
}

.congratsSummary b {
  font-weight: 600;
}

/* ---- Drawn Together: compact player layout so the canvas gets the screen. ---- */

.roomContainer.noHeader .roomHeader,
.roomContainer.noHeader .headerAccent {
  display: none;
}

.playerRoom.drawing {
  padding: 0.5rem;
  box-sizing: border-box;
}

.playerRoom.drawing .drawingInstructions {
  font-size: 0.95rem;
  line-height: 1.25rem;
  margin: 0 0 0.4rem;
  text-align: left;
}

.playerRoom.drawing .drawingStatus {
  font-size: 0.85rem;
  line-height: 1.1rem;
  margin: 0 0 0.4rem;
}

.playerRoom.drawing button {
  height: 2.6rem;
  padding: 0 1rem;
  font-size: 1.05rem;
  margin: 0.3rem 0 0;
}

.posterPicker {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(9rem, 1fr));
  gap: 0.5rem;
  margin: 0.3rem 0;
}

/* The drawer's locked-in poster, shown on its own while the round proceeds. */
.chosenPoster {
  display: flex;
  flex-direction: column;
  align-items: center;
  margin: 0.3rem auto;
}

.chosenPoster img {
  display: block;
  max-width: 100%;
  max-height: calc(100dvh - 10rem);
  aspect-ratio: 2 / 3;
  object-fit: contain;
  border-radius: 10px;
}

.chosenPoster figcaption {
  font-size: 0.75rem;
  line-height: 0.95rem;
  margin-top: 0.3rem;
  color: var(--ink-soft);
}

.posterPicker .poster {
  border: 3px solid transparent;
  border-radius: 12px;
  padding: 3px;
  cursor: pointer;
  text-align: center;
  background: var(--white);
  box-shadow: var(--shadow-card);
  -webkit-tap-highlight-color: transparent;
}

.posterPicker .poster.chosen {
  border-color: var(--navy);
}

.posterPicker .poster img {
  display: block;
  width: 100%;
  aspect-ratio: 2 / 3;
  object-fit: cover;
  border-radius: 8px;
}

.posterPicker .posterLabel {
  display: block;
  font-size: 0.75rem;
  line-height: 0.95rem;
  margin: 0.3rem 0 0.15rem;
  color: var(--ink-soft);
}
`, "",{"version":3,"sources":["webpack://./src/browser/webapp/components/room/room.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,sBAAsB;EACtB,gBAAgB;AAClB;;AAEA;EACE;IACE,iBAAiB;IACjB,kBAAkB;EACpB;AACF;;AAEA;;iBAEiB;AACjB;EACE,aAAa;EACb,qCAAqC;EACrC,kBAAkB;EAClB,YAAY;EACZ,iCAAiC;AACnC;;AAEA;EACE,cAAc;EACd,WAAW;AACb;;AAEA;EACE,aAAa;EACb,YAAY;AACd;;AAEA;EACE;IACE,iBAAiB;EACnB;AACF;;AAEA,gEAAgE;;AAEhE;EACE,WAAW;EACX,sBAAsB;EACtB,4BAA4B;EAC5B,aAAa;EACb,sBAAsB;EACtB,kBAAkB;AACpB;;AAEA,8DAA8D;AAC9D;EACE,kBAAkB;EAClB,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,QAAQ;EACR,wCAAwC;AAC1C;;AAEA;EACE,6BAA6B;EAC7B,gBAAgB;EAChB,kBAAkB;EAClB,iBAAiB;EACjB,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,gCAAgC;EAChC,gBAAgB;EAChB,iBAAiB;EACjB,gBAAgB;EAChB,yBAAyB;EACzB,kBAAkB;EAClB,uBAAuB;AACzB;;AAEA,mEAAmE;AACnE;EACE,gCAAgC;EAChC,gBAAgB;EAChB,iBAAiB;EACjB,iBAAiB;EACjB,mBAAmB;EACnB,kBAAkB;EAClB,uBAAuB;AACzB;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,gBAAgB;EAChB,sBAAsB;EACtB,kBAAkB;AACpB;;AAEA;EACE,sBAAsB;EACtB,kBAAkB;EAClB,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,yBAAyB;EACzB,WAAW;EACX,kBAAkB;AACpB;;AAEA;EACE,SAAS;AACX;;AAEA;EACE,kBAAkB;AACpB;;AAEA,2BAA2B;;AAE3B;EACE,4BAA4B;EAC5B,WAAW;EACX,sBAAsB;EACtB,iCAAiC;EACjC,wCAAwC;EACxC,kBAAkB;AACpB;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,2BAA2B;EAC3B,kBAAkB;EAClB,qBAAqB;AACvB;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA,+CAA+C;AAC/C;EACE,sBAAsB;AACxB;;AAEA;;;EAGE,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,kCAAkC;AACpC;;AAEA;EACE,cAAc;EACd,sBAAsB;EACtB,WAAW;EACX,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,WAAW;EACX,gBAAgB;EAChB,yBAAyB;EACzB,kBAAkB;EAClB,gCAAgC;EAChC,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,wBAAwB;EACxB,8BAA8B;AAChC;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,gCAAgC;EAChC,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,wBAAwB;AAC1B;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,WAAW;EACX,gBAAgB;EAChB,sBAAsB;EACtB,mBAAmB;EACnB,8BAA8B;AAChC;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;EACjB,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;EACjB,sBAAsB;AACxB;;AAEA,uCAAuC;AACvC;EACE,wBAAwB;EACxB,mCAAmC;EACnC,8BAA8B;EAC9B,6BAA6B;AAC/B;;AAEA;EACE,gCAAgC;EAChC,gBAAgB;EAChB,iBAAiB;EACjB,gBAAgB;EAChB,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,YAAY;EACZ,4BAA4B;EAC5B,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,cAAc;EACd,yBAAyB;EACzB,oBAAoB;AACtB;;AAEA;EACE,cAAc;EACd,6BAA6B;EAC7B,oBAAoB;AACtB;;AAEA;EACE,cAAc;EACd,aAAa;EACb,oBAAoB;EACpB,UAAU;EACV,8BAA8B;EAC9B,6BAA6B;EAC7B,4CAA4C;AAC9C;;AAEA;;;;EAIE,0BAA0B;EAC1B,6CAA6C;AAC/C;;AAEA,yBAAyB;;AAEzB;EACE,kBAAkB;EAClB,WAAW;EACX,sBAAsB;EACtB,yBAAyB;EACzB,aAAa;EACb,sBAAsB;EACtB,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,UAAU;AACZ;;AAEA;uCACuC;AACvC;EACE,sDAAsD;AACxD;;AAEA;EACE,uDAAuD;AACzD;;AAEA;EACE,uDAAuD;AACzD;;AAEA;EACE,kBAAkB;EAClB,sBAAsB;AACxB;;AAEA;EACE,eAAe;EACf,SAAS;AACX;;AAEA;EACE,kBAAkB;EAClB,iBAAiB;EACjB,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,WAAW;EACX,oBAAoB;EACpB,OAAO;AACT;;AAEA,oCAAoC;;AAEpC,+DAA+D;AAC/D;EACE;;yFAEuF;AACzF;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,oCAAoC;AACtC;;AAEA,wBAAwB,OAAO,EAAE,QAAQ,EAAE,mBAAmB,EAAE,uBAAuB,EAAE;AACzF,wBAAwB,OAAO,EAAE,SAAS,EAAE,aAAa,EAAE,cAAc,EAAE,qBAAqB,EAAE,uBAAuB,EAAE;AAC3H,wBAAwB,QAAQ,EAAE,SAAS,EAAE,aAAa,EAAE,cAAc,EAAE,qBAAqB,EAAE;AACnG,wBAAwB,QAAQ,EAAE,UAAU,EAAE,qBAAqB,EAAE,uBAAuB,EAAE;AAC9F,wBAAwB,WAAW,EAAE,QAAQ,EAAE,cAAc,EAAE,eAAe,EAAE,qBAAqB,EAAE,uBAAuB,EAAE;AAChI,wBAAwB,UAAU,EAAE,SAAS,EAAE,cAAc,EAAE,eAAe,EAAE,qBAAqB,EAAE;;AAEvG,wBAAwB,OAAO,EAAE,SAAS,EAAE,4BAA4B,EAAE,qBAAqB,EAAE;AACjG,wBAAwB,OAAO,EAAE,UAAU,EAAE,qBAAqB,EAAE;AACpE,wBAAwB,QAAQ,EAAE,QAAQ,EAAE,uBAAuB,EAAE,mBAAmB,EAAE;AAC1F,wBAAwB,WAAW,EAAE,SAAS,EAAE,uBAAuB,EAAE,qBAAqB,EAAE;;AAEhG;EACE,kDAAkD;AACpD;;AAEA;;EAEE,yBAAyB;EACzB,iDAAiD;AACnD;;AAEA;EACE,mCAAmC;AACrC;;AAEA;EACE,qDAAqD;AACvD;;AAEA,wDAAwD;AACxD;EACE,4DAA4D;EAC5D,mBAAmB;EACnB,gDAAgD;AAClD;;AAEA,8CAA8C;AAC9C;EACE,2EAA2E;AAC7E;;AAEA;EACE,uBAAuB;EACvB,kFAAkF;AACpF;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,WAAW;EACX,sBAAsB;EACtB,iCAAiC;EACjC,4DAA4D;EAC5D,mBAAmB;EACnB,gCAAgC;EAChC,gBAAgB;EAChB,kBAAkB;EAClB,gBAAgB;EAChB,gDAAgD;EAChD;;6CAE2C;AAC7C;;AAEA;;EAEE,WAAW;EACX,aAAa;EACb,cAAc;EACd,wBAAwB;EACxB,wFAAwF;EACxF,4CAA4C;AAC9C;;AAEA;EACE,qBAAqB;AACvB;;AAEA,oDAAoD;AACpD;EACE,kDAAkD;AACpD;;AAEA;EACE,OAAO,UAAU,EAAE;EACnB,KAAK,UAAU,EAAE;AACnB;;AAEA;EACE,KAAK,qBAAqB,EAAE,YAAY,EAAE;EAC1C,MAAM,sBAAsB,EAAE,UAAU,EAAE;EAC1C,OAAO,mBAAmB,EAAE,UAAU,EAAE;AAC1C;;AAEA;EACE,WAAW,wCAAwC,EAAE;EACrD,MAAM,4CAA4C,EAAE;AACtD;;AAEA;EACE,WAAW,0CAA0C,EAAE;EACvD,MAAM,8CAA8C,EAAE;AACxD;;AAEA;EACE,KAAK,iCAAiC,EAAE;EACxC,MAAM,sCAAsC,EAAE;EAC9C,MAAM,uCAAuC,EAAE;EAC/C,OAAO,iCAAiC,EAAE;AAC5C;;AAEA;EACE,KAAK,mBAAmB,EAAE;EAC1B,MAAM,mCAAmC,EAAE;EAC3C,OAAO,gCAAgC,EAAE;AAC3C;;AAEA;EACE,WAAW,gDAAgD,EAAE;EAC7D,MAAM,8CAA8C,EAAE;AACxD;;AAEA;EACE;IACE,sEAAsE;EACxE;EACA;IACE,sEAAsE;EACxE;AACF;;AAEA;EACE;;;;;;;;;;;;;;;IAeE,eAAe;EACjB;AACF;;AAEA;EACE,eAAe;EACf,wBAAwB;EACxB,iCAAiC;EACjC,8BAA8B;EAC9B,+BAA+B;EAC/B,kBAAkB;EAClB,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,sBAAsB;EACtB,sBAAsB;AACxB;;AAEA;EACE,mBAAmB;EACnB,iBAAiB;AACnB;;AAEA;EACE,cAAc;EACd,YAAY;EACZ,aAAa;EACb,kBAAkB;EAClB,sBAAsB;AACxB;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,qBAAqB;EACrB,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,sBAAsB;EACtB,iBAAiB;EACjB,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,sBAAsB;EACtB,gCAAgC;EAChC,gBAAgB;EAChB,iBAAiB;EACjB,iBAAiB;EACjB,qBAAqB;EACrB,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;EAClB,sBAAsB;AACxB;;AAEA;EACE,OAAO;EACP,YAAY;EACZ,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;EACT,qBAAqB;AACvB;;AAEA;EACE,SAAS;EACT,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,YAAY;EACZ,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,wBAAwB;EACxB,mCAAmC;EACnC,8BAA8B;EAC9B,uBAAuB;EACvB,gCAAgC;AAClC;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,OAAO;EACP,YAAY;EACZ,aAAa;EACb,sBAAsB;EACtB,YAAY;AACd;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,YAAY;AACd;;AAEA;EACE,gCAAgC;EAChC,gBAAgB;EAChB,iBAAiB;EACjB,gBAAgB;EAChB,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,oBAAoB;EACpB,mBAAmB;EACnB,WAAW;EACX,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,cAAc;EACd,kBAAkB;EAClB,uBAAuB;EACvB,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,aAAa;EACb,WAAW;EACX,aAAa;EACb,cAAc;EACd,sCAAsC;EACtC,uCAAuC;EACvC,wBAAwB;AAC1B;;AAEA;EACE,eAAe;EACf,oBAAoB;EACpB,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,YAAY;EACZ,oBAAoB;EACpB,kCAAkC;EAClC,6BAA6B;AAC/B;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,cAAc;EACd,aAAa;EACb,mBAAmB;EACnB,cAAc;EACd,aAAa;EACb,kBAAkB;EAClB,sBAAsB;EACtB,uBAAuB;EACvB,iBAAiB;EACjB,cAAc;EACd,eAAe;EACf,sBAAsB;EACtB,6DAA6D;AAC/D;;AAEA;EACE,mBAAmB;EACnB,yBAAyB;AAC3B;;AAEA;EACE,wBAAwB;EACxB,kBAAkB;EAClB,kBAAkB;EAClB,gBAAgB;EAChB,sBAAsB;AACxB;;AAEA;EACE,gBAAgB;EAChB,wBAAwB;EACxB,mCAAmC;EACnC,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,YAAY;EACZ,gBAAgB;AAClB;;AAEA;EACE,SAAS;AACX;;AAEA;EACE,OAAO;EACP,gBAAgB;AAClB;;AAEA;EACE;IACE,4BAA4B;EAC9B;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,sBAAsB;EACxB;;EAEA;IACE,gBAAgB;IAChB,mBAAmB;EACrB;AACF;;AAEA,qCAAqC;;AAErC;;EAEE,sBAAsB;EACtB,kBAAkB;EAClB,kBAAkB;EAClB,aAAa;EACb,0CAA0C;EAC1C,sBAAsB;EACtB,+EAA+E;EAC/E,gBAAgB;EAChB,aAAa;EACb,sBAAsB;EACtB,oBAAoB;EACpB,YAAY;AACd;;AAEA;;EAEE,cAAc;AAChB;;AAEA;iCACiC;AACjC;;EAEE,WAAW;EACX,eAAe;EACf,gBAAgB;AAClB;;AAEA;;;4BAG4B;AAC5B;;;;EAIE,uDAAuD;EACvD,cAAc;AAChB;;AAEA;qDACqD;AACrD;;EAEE,oBAAoB;AACtB;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,oCAAoC;AACtC;;AAEA;;EAEE,UAAU;AACZ;;AAEA,yDAAyD;AACzD;;EAEE,iBAAiB;AACnB;;AAEA;;EAEE,eAAe;EACf,wBAAwB;AAC1B;;AAEA;;EAEE,eAAe;AACjB;;AAEA;;EAEE,kBAAkB;EAClB,kBAAkB;EAClB,sBAAsB;AACxB;;AAEA;;EAEE,aAAa;EACb,cAAc;EACd,iBAAiB;AACnB;;AAEA;;EAEE,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,gCAAgC;EAChC,gBAAgB;EAChB,kBAAkB;EAClB,kBAAkB;EAClB,mBAAmB;EACnB,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,YAAY;EACZ,gBAAgB;EAChB,iBAAiB;EACjB,iBAAiB;EACjB,SAAS;EACT,uBAAuB;AACzB;;AAEA;EACE,cAAc;EACd,6BAA6B;EAC7B,iBAAiB;EACjB,gBAAgB;EAChB,iBAAiB;EACjB,iBAAiB;EACjB,YAAY;EACZ,eAAe;AACjB;;AAEA;EACE,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,iBAAiB;EACjB,gBAAgB;EAChB,sBAAsB;EACtB,kBAAkB;AACpB;;AAEA,6DAA6D;AAC7D;;EAEE,kBAAkB;EAClB,SAAS;EACT,cAAc;EACd,UAAU;AACZ;;AAEA;EACE,iBAAiB;EACjB,sBAAsB;AACxB;;AAEA;EACE,yBAAyB;EACzB,mBAAmB;EACnB,aAAa;AACf;;AAEA;EACE,gCAAgC;EAChC,gBAAgB;EAChB,iBAAiB;EACjB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA,iEAAiE;;AAEjE;EACE,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,kBAAkB;EAClB,uBAAuB;AACzB;;AAEA;EACE;4DAC0D;EAC1D,kBAAkB;EAClB,iBAAiB;EACjB,oBAAoB;EACpB,wBAAwB;EACxB,8BAA8B;EAC9B,kBAAkB;EAClB,UAAU;EACV,8BAA8B;EAC9B,iCAAiC;EACjC,8CAA8C;EAC9C,sBAAsB;EACtB,UAAU;EACV,yDAAyD;AAC3D;;AAEA;sEACsE;AACtE;EACE,kBAAkB;AACpB;;AAEA,4EAA4E;AAC5E;EACE,8CAA8C;EAC9C,aAAa;EACb,sBAAsB;EACtB,8BAA8B;EAC9B,YAAY;EACZ,8BAA8B;AAChC;;AAEA;;;;EAIE,SAAS;AACX;;AAEA;EACE,SAAS;AACX;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE;IACE,UAAU;IACV,2BAA2B;EAC7B;EACA;IACE,UAAU;IACV,wBAAwB;EAC1B;AACF;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,cAAc;EACd,UAAU;AACZ;;AAEA,iHAAiH;;AAEjH;EACE,iBAAiB;EACjB,iBAAiB;EACjB,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,iBAAiB;EACjB,eAAe;AACjB;;AAEA;EACE,iBAAiB;EACjB,eAAe;EACf,oBAAoB;AACtB;;AAEA;EACE,aAAa;EACb,iBAAiB;EACjB,iBAAiB;EACjB,qBAAqB;EACrB,mCAAmC;EACnC,YAAY;AACd;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,oCAAoC;AACtC;;AAEA;;EAEE,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,gBAAgB;EAChB,iBAAiB;EACjB,6BAA6B;AAC/B;;AAEA;EACE,YAAY;EACZ,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;EACnB,iBAAiB;EACjB,gBAAgB;EAChB,gCAAgC;EAChC,gBAAgB;AAClB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;AAClB;;AAEA,mFAAmF;;AAEnF;;EAEE,aAAa;AACf;;AAEA;EACE,eAAe;EACf,sBAAsB;AACxB;;AAEA;EACE,kBAAkB;EAClB,oBAAoB;EACpB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,0DAA0D;EAC1D,WAAW;EACX,gBAAgB;AAClB;;AAEA,8EAA8E;AAC9E;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gCAAgC;EAChC,mBAAmB;EACnB,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,oBAAoB;EACpB,kBAAkB;EAClB,sBAAsB;AACxB;;AAEA;EACE,6BAA6B;EAC7B,mBAAmB;EACnB,YAAY;EACZ,eAAe;EACf,kBAAkB;EAClB,wBAAwB;EACxB,8BAA8B;EAC9B,wCAAwC;AAC1C;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,cAAc;EACd,WAAW;EACX,mBAAmB;EACnB,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,oBAAoB;EACpB,wBAAwB;EACxB,sBAAsB;AACxB","sourcesContent":[".roomContainer {\n  display: flex;\n  flex-direction: column;\n  min-height: 100%;\n}\n\n@media (max-width: 600px) {\n  .roomContainer {\n    min-height: 100vh;\n    min-height: 100dvh;\n  }\n}\n\n/* A single-cell grid: the team panels and the all-play overlay share the\n   cell, so the card grows to fit whichever is taller instead of clipping\n   the overlay. */\n.roomContent {\n  display: grid;\n  grid-template-columns: minmax(0, 1fr);\n  position: relative;\n  flex-grow: 1;\n  min-height: var(--content-height);\n}\n\n.roomContent > * {\n  grid-column: 1;\n  grid-row: 1;\n}\n\n.teamPanels {\n  display: flex;\n  min-width: 0;\n}\n\n@media (max-width: 600px) {\n  .roomContent {\n    min-height: unset;\n  }\n}\n\n/* ---- Shared move layout (host panels and player phone) ---- */\n\n.movePanel {\n  width: 100%;\n  box-sizing: border-box;\n  padding: 1.25rem 1.5rem 1rem;\n  display: flex;\n  flex-direction: column;\n  text-align: center;\n}\n\n/* Status pill row; the ring timer floats at the right edge. */\n.moveTop {\n  position: relative;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  min-height: 3rem;\n  margin: 0 0 0.75rem;\n}\n\n.moveTop .timer {\n  position: absolute;\n  right: 0;\n  top: 50%;\n  margin-top: calc(var(--timer-size) / -2);\n}\n\n.moveKicker {\n  font-family: var(--font-body);\n  font-weight: 700;\n  font-size: 1.15rem;\n  color: var(--ink);\n  margin: 0.4rem 0 0;\n  text-align: center;\n}\n\n.moveQuestion {\n  font-family: var(--font-heading);\n  font-weight: 600;\n  font-size: 2.6rem;\n  line-height: 1.1;\n  margin: 0.15rem 0 1.25rem;\n  text-align: center;\n  overflow-wrap: anywhere;\n}\n\n/* Whose turn — the visual center of Read the Room / Fact or Fib. */\n.moveTurn {\n  font-family: var(--font-heading);\n  font-weight: 600;\n  font-size: 2.4rem;\n  line-height: 1.05;\n  margin: 0 0 0.35rem;\n  text-align: center;\n  overflow-wrap: anywhere;\n}\n\n.moveTurn.team1 {\n  color: var(--team1-text);\n}\n\n.moveTurn.team2 {\n  color: var(--team2-text);\n}\n\n.moveFooter {\n  margin: 1rem 0 0;\n  font-size: 0.95rem;\n  font-weight: 700;\n  color: var(--ink-soft);\n  text-align: center;\n}\n\n.formHint {\n  color: var(--ink-soft);\n  font-size: 0.95rem;\n  margin: -0.5rem 0 0.75rem;\n}\n\n.formActions {\n  display: flex;\n  justify-content: flex-end;\n  gap: 0.5rem;\n  margin-top: 0.5rem;\n}\n\n.formActions button {\n  margin: 0;\n}\n\n.formActions .back {\n  margin-right: auto;\n}\n\n/* ---- Player phone ---- */\n\n.playerRoom {\n  padding: 1rem 1.25rem 1.5rem;\n  width: 100%;\n  box-sizing: border-box;\n  background-color: var(--sky-soft);\n  transition: background-color 0.6s linear;\n  text-align: center;\n}\n\n.playerRoom .movePanel {\n  padding: 0;\n}\n\n.playerRoom .moveTop {\n  justify-content: flex-start;\n  min-height: 4.5rem;\n  margin-bottom: 0.5rem;\n}\n\n.playerRoom .moveTop .statusPill {\n  font-size: 1.1rem;\n  white-space: normal;\n  text-align: center;\n}\n\n/* Leave room for the timer next to the pill. */\n.playerRoom .moveTop:has(.timer) {\n  padding-right: 5.25rem;\n}\n\n.playerRoom .moveKicker,\n.playerRoom .moveQuestion,\n.playerRoom .formHint {\n  text-align: left;\n}\n\n.playerRoom .moveQuestion {\n  font-size: 2.2rem;\n  margin-bottom: 1rem;\n}\n\n.playerRoom.team1 {\n  background-color: var(--sky);\n}\n\n.playerRoom.team2 {\n  background-color: var(--pink-soft);\n}\n\n.playerRoom textarea {\n  display: block;\n  box-sizing: border-box;\n  width: 100%;\n  min-width: unset;\n  text-align: left;\n}\n\n.playerRoom input[type=\"text\"] {\n  display: block;\n  width: 100%;\n  min-width: unset;\n  margin: 0.25rem 0 0.75rem;\n  text-align: center;\n  font-family: var(--font-heading);\n  font-weight: 600;\n  font-size: 1.4rem;\n}\n\n.playerRoom .moveFooter {\n  margin-top: 0.9rem;\n}\n\n.playerRoom .teamList {\n  margin-top: 0.75rem;\n}\n\n.playerRoom .teamListItem {\n  background: var(--white);\n  box-shadow: var(--shadow-card);\n}\n\n.gameRecap .moveKicker {\n  text-align: center;\n}\n\n.recapScore {\n  font-family: var(--font-heading);\n  font-weight: 600;\n  font-size: 3rem;\n  line-height: 1.05;\n  margin: 0.35rem 0 0.6rem;\n}\n\n.recapMoment {\n  font-size: 1.15rem;\n  font-weight: 700;\n  margin: 0 0 1rem;\n}\n\n.recapPoster {\n  display: block;\n  width: 100%;\n  max-width: 14rem;\n  margin: 0 auto 0.25rem;\n  border-radius: 12px;\n  box-shadow: var(--shadow-card);\n}\n\n.waitingRoom {\n  text-align: center;\n  padding-top: 0.5rem;\n}\n\n.waitingRoom .moveTop {\n  justify-content: center;\n}\n\n.waitingRoom .moveQuestion {\n  text-align: center;\n  margin-top: 1.5rem;\n}\n\n.waitingRoom button {\n  margin-top: 1.5rem;\n}\n\n.nameForm {\n  text-align: left;\n}\n\n.charCount {\n  text-align: right;\n  margin: 0 0 0.6rem;\n  font-weight: 700;\n  font-size: 0.9rem;\n  color: var(--ink-soft);\n}\n\n/* Slider (Group Think) on the phone. */\n.sliderCard {\n  background: var(--white);\n  border-radius: var(--border-radius);\n  box-shadow: var(--shadow-card);\n  padding: 1rem 1.25rem 1.25rem;\n}\n\n.sliderValue {\n  font-family: var(--font-heading);\n  font-weight: 600;\n  font-size: 2.4rem;\n  line-height: 1.1;\n  color: var(--ink);\n  margin: 0 0 0.5rem;\n}\n\n.sliderCard .rc-slider {\n  width: unset;\n  margin: 1rem 0.75rem 0.25rem;\n  height: 2.5rem;\n  padding: 0.8rem 0;\n}\n\n.sliderCard .rc-slider-rail {\n  height: 0.9rem;\n  background-color: #dbe7f5;\n  border-radius: 999px;\n}\n\n.sliderCard .rc-slider-track {\n  height: 0.9rem;\n  background-color: var(--navy);\n  border-radius: 999px;\n}\n\n.sliderCard .rc-slider-handle {\n  height: 2.2rem;\n  width: 2.2rem;\n  margin-top: -0.65rem;\n  opacity: 1;\n  border: 3px solid var(--white);\n  background-color: var(--navy);\n  box-shadow: 0 2px 6px rgba(14, 36, 99, 0.35);\n}\n\n.sliderCard .rc-slider-handle:hover,\n.sliderCard .rc-slider-handle:active,\n.sliderCard .rc-slider-handle:focus-visible,\n.sliderCard .rc-slider-handle-dragging.rc-slider-handle-dragging.rc-slider-handle-dragging {\n  border-color: var(--white);\n  box-shadow: 0 0 0 4px rgba(23, 53, 127, 0.25);\n}\n\n/* ---- Host lobby ---- */\n\n.lobby {\n  position: relative;\n  width: 100%;\n  box-sizing: border-box;\n  padding: 1.5rem 2rem 2rem;\n  display: flex;\n  flex-direction: column;\n  overflow: hidden;\n}\n\n.lobby > * {\n  position: relative;\n  z-index: 1;\n}\n\n/* Arriving from the landing page through the split wipe: the lobby rises\n   into place as the ice breaks open. */\n.roomContainer.entering .lobbyTitle {\n  animation: landIn 0.6s var(--bounce-effect) 0.45s both;\n}\n\n.roomContainer.entering .joinPanel {\n  animation: landIn 0.65s var(--bounce-effect) 0.55s both;\n}\n\n.roomContainer.entering .playersPanel {\n  animation: landIn 0.65s var(--bounce-effect) 0.65s both;\n}\n\n.lobbyTitle {\n  text-align: center;\n  margin-bottom: 1.25rem;\n}\n\n.lobbyTitle h1 {\n  font-size: 3rem;\n  margin: 0;\n}\n\n.lobbyTitle p {\n  margin: 0.2rem 0 0;\n  font-size: 1.1rem;\n  font-weight: 700;\n  color: var(--ink);\n}\n\n.lobbyBody {\n  display: flex;\n  gap: 1.5rem;\n  align-items: stretch;\n  flex: 1;\n}\n\n/* ---- Lobby: everybody's in ---- */\n\n/* Same pink/blue wash and sparkle field as the landing page. */\n.lobby.allReady {\n  background:\n    radial-gradient(ellipse 55% 42% at 12% -8%, rgba(240, 110, 163, 0.22), transparent 70%),\n    radial-gradient(ellipse 50% 40% at 92% 0%, rgba(56, 182, 245, 0.28), transparent 68%);\n}\n\n.lobby > .lobbyDecor {\n  position: absolute;\n  z-index: 0;\n  animation: fadeIn 0.8s ease-out both;\n}\n\n.lobbyDecor .spark.s1 { top: 4%; left: 4%; animation-delay: 0s; background: var(--pink); }\n.lobbyDecor .spark.s2 { top: 7%; right: 5%; width: 0.8rem; height: 0.8rem; animation-delay: 0.4s; background: var(--blue); }\n.lobbyDecor .spark.s3 { top: 16%; left: 24%; width: 0.7rem; height: 0.7rem; animation-delay: 0.9s; }\n.lobbyDecor .spark.s4 { top: 14%; right: 26%; animation-delay: 1.3s; background: var(--pink); }\n.lobbyDecor .spark.s5 { bottom: 14%; left: 5%; width: 0.65rem; height: 0.65rem; animation-delay: 0.6s; background: var(--blue); }\n.lobbyDecor .spark.s6 { bottom: 6%; left: 20%; width: 0.85rem; height: 0.85rem; animation-delay: 1.6s; }\n\n.lobbyDecor .flake.f1 { top: 9%; left: 29%; background: var(--pink-soft); animation-delay: 0.2s; }\n.lobbyDecor .flake.f2 { top: 5%; right: 32%; animation-delay: 1.1s; }\n.lobbyDecor .flake.f3 { top: 58%; left: 8%; background: var(--blue); animation-delay: 2s; }\n.lobbyDecor .flake.f4 { bottom: 22%; left: 24%; background: var(--pink); animation-delay: 2.8s; }\n\n.lobby.allReady .lobbyTitle h1 {\n  animation: titlePop 0.7s var(--bounce-effect) both;\n}\n\n.lobby.allReady .lobbyTitle h1::before,\n.lobby.allReady .lobbyTitle h1::after {\n  border-color: var(--pink);\n  animation: chevronNudge 1.6s ease-in-out infinite;\n}\n\n.lobby.allReady .lobbyTitle h1::after {\n  animation-name: chevronNudgeReverse;\n}\n\n.lobby.allReady .lobbyTitle p {\n  animation: landIn 0.6s var(--bounce-effect) 0.1s both;\n}\n\n/* Ready count pill turns into the pink→blue gradient. */\n.lobby.allReady .playersHeading .pill {\n  background: linear-gradient(90deg, var(--pink), var(--blue));\n  color: var(--white);\n  animation: landIn 0.5s var(--bounce-effect) both;\n}\n\n/* Rows cheer in order, and each check pops. */\n.lobby.allReady .playerRow.ready {\n  animation: rowCheer 0.6s var(--bounce-effect) calc(var(--i, 0) * 70ms) both;\n}\n\n.lobby.allReady .playerRow.ready .readyCheck {\n  background: var(--pink);\n  animation: checkPop 0.5s var(--bounce-effect) calc(var(--i, 0) * 70ms + 0.2s) both;\n}\n\n.lobby.allReady .playerRow.ready .readyCheck::after {\n  border-color: var(--white);\n}\n\n.lobby.allReady .waitingText {\n  margin-top: 1.1rem;\n}\n\n.readyBanner {\n  display: inline-flex;\n  align-items: center;\n  gap: 0.6rem;\n  padding: 0.5rem 1.4rem;\n  border-radius: var(--pill-radius);\n  background: linear-gradient(90deg, var(--pink), var(--blue));\n  color: var(--white);\n  font-family: var(--font-heading);\n  font-weight: 600;\n  font-size: 1.15rem;\n  line-height: 1.2;\n  box-shadow: 0 6px 16px rgba(240, 110, 163, 0.28);\n  animation:\n    landIn 0.6s var(--bounce-effect) 0.3s both,\n    bannerGlow 2.4s ease-in-out 0.9s infinite;\n}\n\n.readyBanner::before,\n.readyBanner::after {\n  content: \"\";\n  width: 0.7rem;\n  height: 0.7rem;\n  background: var(--white);\n  clip-path: polygon(50% 0, 62% 38%, 100% 50%, 62% 62%, 50% 100%, 38% 62%, 0 50%, 38% 38%);\n  animation: twinkle 1.8s ease-in-out infinite;\n}\n\n.readyBanner::after {\n  animation-delay: 0.9s;\n}\n\n/* Start game gets the sweep and a soft heartbeat. */\n.lobby.allReady .lobbyActions .startGame:not(:disabled) {\n  animation: startPulse 2s ease-in-out 0.6s infinite;\n}\n\n@keyframes fadeIn {\n  from { opacity: 0; }\n  to { opacity: 1; }\n}\n\n@keyframes titlePop {\n  0% { transform: scale(0.9); opacity: 0.4; }\n  55% { transform: scale(1.06); opacity: 1; }\n  100% { transform: scale(1); opacity: 1; }\n}\n\n@keyframes chevronNudge {\n  0%, 100% { transform: rotate(45deg) translate(0, 0); }\n  50% { transform: rotate(45deg) translate(3px, 3px); }\n}\n\n@keyframes chevronNudgeReverse {\n  0%, 100% { transform: rotate(-135deg) translate(0, 0); }\n  50% { transform: rotate(-135deg) translate(3px, 3px); }\n}\n\n@keyframes rowCheer {\n  0% { transform: translateX(0) scale(1); }\n  35% { transform: translateX(6px) scale(1.02); }\n  70% { transform: translateX(-2px) scale(1.01); }\n  100% { transform: translateX(0) scale(1); }\n}\n\n@keyframes checkPop {\n  0% { transform: scale(1); }\n  45% { transform: scale(1.45) rotate(8deg); }\n  100% { transform: scale(1) rotate(0deg); }\n}\n\n@keyframes bannerGlow {\n  0%, 100% { box-shadow: 0 6px 16px rgba(240, 110, 163, 0.28); }\n  50% { box-shadow: 0 6px 22px rgba(56, 182, 245, 0.5); }\n}\n\n@keyframes startPulse {\n  0%, 100% {\n    box-shadow: 0 3px 0 var(--navy-deep), 0 0 0 0 rgba(56, 182, 245, 0.55);\n  }\n  50% {\n    box-shadow: 0 3px 0 var(--navy-deep), 0 0 0 10px rgba(56, 182, 245, 0);\n  }\n}\n\n@media (prefers-reduced-motion: reduce) {\n  .roomContainer.entering .lobbyTitle,\n  .roomContainer.entering .joinPanel,\n  .roomContainer.entering .playersPanel,\n  .lobby > .lobbyDecor,\n  .lobby.allReady .lobbyTitle h1,\n  .lobby.allReady .lobbyTitle h1::before,\n  .lobby.allReady .lobbyTitle h1::after,\n  .lobby.allReady .lobbyTitle p,\n  .lobby.allReady .playersHeading .pill,\n  .lobby.allReady .playerRow.ready,\n  .lobby.allReady .playerRow.ready .readyCheck,\n  .readyBanner,\n  .readyBanner::before,\n  .readyBanner::after,\n  .lobby.allReady .lobbyActions .startGame:not(:disabled) {\n    animation: none;\n  }\n}\n\n.joinPanel {\n  flex: 0 0 18rem;\n  background: var(--white);\n  border-radius: var(--card-radius);\n  box-shadow: var(--shadow-card);\n  padding: 1.25rem 1.25rem 1.5rem;\n  text-align: center;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  align-self: flex-start;\n  box-sizing: border-box;\n}\n\n.joinPanel h2 {\n  margin: 0 0 0.75rem;\n  font-size: 1.7rem;\n}\n\n.qr {\n  display: block;\n  width: 12rem;\n  height: 12rem;\n  border-radius: 8px;\n  box-sizing: border-box;\n}\n\nspan.qr {\n  background: var(--sky-soft);\n}\n\n.joinLabel {\n  margin: 1rem 0 0.4rem;\n  font-weight: 700;\n  font-size: 0.95rem;\n}\n\n.roomCodeBig {\n  background: var(--sky);\n  color: var(--ink);\n  border-radius: 12px;\n  padding: 0.35rem 1.5rem;\n  min-width: 5rem;\n  box-sizing: border-box;\n  font-family: var(--font-heading);\n  font-weight: 600;\n  font-size: 2.8rem;\n  line-height: 1.15;\n  letter-spacing: 0.1em;\n  text-transform: uppercase;\n}\n\n.joinHint {\n  margin: 0.75rem 0 0;\n  font-size: 0.85rem;\n  color: var(--ink-soft);\n}\n\n.playersPanel {\n  flex: 1;\n  min-width: 0;\n  display: flex;\n  flex-direction: column;\n}\n\n.playersHeading {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 1rem;\n  margin-bottom: 0.6rem;\n}\n\n.playersHeading h2 {\n  margin: 0;\n  font-size: 1.7rem;\n}\n\n.playerList {\n  display: flex;\n  flex-direction: column;\n  gap: 0.55rem;\n  min-height: 6rem;\n}\n\n.playerRow {\n  display: flex;\n  align-items: center;\n  gap: 0.8rem;\n  background: var(--white);\n  border-radius: var(--border-radius);\n  box-shadow: var(--shadow-card);\n  padding: 0.55rem 0.9rem;\n  transition: opacity 0.15s linear;\n}\n\n.playerRow.loading {\n  opacity: 0.4;\n}\n\n.playerRow.inactive {\n  opacity: 0.55;\n}\n\n.playerRowMain {\n  flex: 1;\n  min-width: 0;\n  display: flex;\n  flex-direction: column;\n  gap: 0.35rem;\n}\n\n.playerRowTop {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 0.75rem;\n}\n\n.playerName {\n  font-family: var(--font-heading);\n  font-weight: 600;\n  font-size: 1.2rem;\n  line-height: 1.2;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n\n.playerStatus {\n  flex-shrink: 0;\n  display: inline-flex;\n  align-items: center;\n  gap: 0.4rem;\n  font-size: 0.95rem;\n  font-weight: 700;\n  color: var(--ink);\n}\n\n.readyCheck {\n  width: 1.3rem;\n  height: 1.3rem;\n  border-radius: 50%;\n  background: var(--navy);\n  position: relative;\n}\n\n.readyCheck::after {\n  content: \"\";\n  position: absolute;\n  left: 0.42rem;\n  top: 0.2rem;\n  width: 0.3rem;\n  height: 0.6rem;\n  border-right: 2.5px solid var(--white);\n  border-bottom: 2.5px solid var(--white);\n  transform: rotate(45deg);\n}\n\n.progressContainer {\n  height: 0.55rem;\n  border-radius: 999px;\n  background: #e3ebf7;\n  overflow: hidden;\n}\n\n.progressIndicator {\n  height: 100%;\n  border-radius: 999px;\n  transition: width 0.5s ease-in-out;\n  background-color: var(--blue);\n}\n\n.playerRow.pink .progressIndicator {\n  background-color: var(--pink);\n}\n\n.kickPlayer {\n  flex-shrink: 0;\n  display: grid;\n  place-items: center;\n  height: 1.6rem;\n  width: 1.6rem;\n  border-radius: 50%;\n  color: var(--ink-soft);\n  background: transparent;\n  font-size: 1.1rem;\n  line-height: 1;\n  cursor: pointer;\n  box-sizing: border-box;\n  transition: background-color 0.12s linear, color 0.12s linear;\n}\n\n.kickPlayer:hover {\n  background: #fde3ec;\n  color: var(--error-color);\n}\n\n.waitingText {\n  margin: 0.9rem 0 0.25rem;\n  text-align: center;\n  font-size: 0.95rem;\n  font-weight: 700;\n  color: var(--ink-soft);\n}\n\n.roundTypeStart {\n  margin-top: auto;\n  background: var(--paper);\n  border-radius: var(--border-radius);\n  padding: 0.75rem 1rem;\n}\n\n.lobbyActions {\n  display: flex;\n  justify-content: space-between;\n  gap: 0.75rem;\n  margin-top: 1rem;\n}\n\n.lobbyActions button {\n  margin: 0;\n}\n\n.lobbyActions button:last-child {\n  flex: 1;\n  max-width: 20rem;\n}\n\n@media (max-width: 720px) {\n  .lobby {\n    padding: 1.25rem 1rem 1.5rem;\n  }\n\n  .lobbyTitle h1 {\n    font-size: 2.2rem;\n  }\n\n  .lobbyBody {\n    flex-direction: column;\n  }\n\n  .joinPanel {\n    flex-basis: auto;\n    align-self: stretch;\n  }\n}\n\n/* ---- Host game: team panels ---- */\n\n.leftTeamContainer,\n.rightTeamContainer {\n  --panel-pad-x: 1.25rem;\n  position: relative;\n  text-align: center;\n  flex: 0 1 50%;\n  padding: 1.25rem var(--panel-pad-x) 1.5rem;\n  box-sizing: border-box;\n  transition: flex 0.2s linear, padding 0.2s linear, background-color 0.3s linear;\n  overflow: hidden;\n  display: flex;\n  flex-direction: column;\n  align-items: stretch;\n  min-width: 0;\n}\n\n.leftTeamContainer.full,\n.rightTeamContainer.full {\n  flex: 1 0 100%;\n}\n\n/* The idle panel collapses completely (padding included) so the active one\n   really spans the whole room. */\n.leftTeamContainer.full + .rightTeamContainer,\n.leftTeamContainer:has(+ .rightTeamContainer.full) {\n  flex: 0 0 0;\n  padding-left: 0;\n  padding-right: 0;\n}\n\n/* Lay the active panel's content out at its final, full-room width right\n   away, so it is revealed by the slide rather than stretched with it.\n   Only size in-flow panel content — marquees overlay the room and must\n   not inherit this width. */\n.leftTeamContainer.full > .movePanel,\n.leftTeamContainer.full > .allPlay,\n.rightTeamContainer.full > .movePanel,\n.rightTeamContainer.full > .allPlay {\n  width: calc(var(--room-width) - 2 * var(--panel-pad-x));\n  flex-shrink: 0;\n}\n\n/* The right panel grows leftward, so pin its content to the right edge\n   (its resting place) and let the wipe uncover it. */\n.rightTeamContainer.full > .movePanel,\n.rightTeamContainer.full > .allPlay {\n  align-self: flex-end;\n}\n\n.leftTeamContainer {\n  background-color: var(--team1-panel);\n}\n\n.rightTeamContainer {\n  background-color: var(--team2-panel);\n}\n\n.leftTeamContainer .movePanel,\n.rightTeamContainer .movePanel {\n  padding: 0;\n}\n\n/* Big-screen sizing for the question and answer cards. */\n.leftTeamContainer .moveKicker,\n.rightTeamContainer .moveKicker {\n  font-size: 1.3rem;\n}\n\n.leftTeamContainer .moveTurn,\n.rightTeamContainer .moveTurn {\n  font-size: 5rem;\n  margin: 0.1rem 0 0.55rem;\n}\n\n.leftTeamContainer .moveQuestion,\n.rightTeamContainer .moveQuestion {\n  font-size: 3rem;\n}\n\n.leftTeamContainer .movePanel .radiobtn label,\n.rightTeamContainer .movePanel .radiobtn label {\n  font-size: 1.35rem;\n  min-height: 4.3rem;\n  padding: 0.7rem 0.9rem;\n}\n\n.leftTeamContainer .movePanel .optionBadge,\n.rightTeamContainer .movePanel .optionBadge {\n  width: 2.9rem;\n  height: 2.9rem;\n  font-size: 1.6rem;\n}\n\n.leftTeamContainer .moveFooter,\n.rightTeamContainer .moveFooter {\n  font-size: 1.05rem;\n  margin-top: 1.25rem;\n}\n\n.sideBetTally {\n  font-family: var(--font-heading);\n  font-weight: 600;\n  font-size: 1.15rem;\n  text-align: center;\n  margin: 0.85rem 0 0;\n  color: var(--ink-soft);\n}\n\n.sideBetChoices {\n  display: grid;\n  grid-template-columns: 1fr 1fr;\n  gap: 0.75rem;\n  margin-top: 0.5rem;\n}\n\n.sideBetChoices button {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  gap: 0.25rem;\n  min-height: 6rem;\n  font-size: 1.6rem;\n  line-height: 1.05;\n  margin: 0;\n  padding: 0.7rem 0.55rem;\n}\n\n.sideBetChoices .sideBetCaption {\n  display: block;\n  font-family: var(--font-body);\n  font-size: 0.8rem;\n  font-weight: 800;\n  letter-spacing: 0;\n  line-height: 1.25;\n  opacity: 0.8;\n  max-width: 12em;\n}\n\n.sideBetChoices button.chosen {\n  background: var(--navy);\n  color: var(--white);\n}\n\n.playerRoom .sideBetStakes {\n  color: var(--ink);\n  margin-top: 0.85rem;\n}\n\n.playerRoom .sideBetHint {\n  margin: 0.3rem 0 0;\n  font-size: 0.9rem;\n  font-weight: 700;\n  color: var(--ink-soft);\n  text-align: center;\n}\n\n/* Timer rides in the top-right corner of the active panel. */\n.leftTeamContainer > .timer,\n.rightTeamContainer > .timer {\n  position: absolute;\n  top: 1rem;\n  right: 1.25rem;\n  z-index: 2;\n}\n\n.teamTitle {\n  font-size: 1.9rem;\n  margin: 0.25rem 0 1rem;\n}\n\n.scoreDivider {\n  margin: auto 1rem 0.75rem;\n  align-self: stretch;\n  opacity: 0.25;\n}\n\n.scoreContainer {\n  font-family: var(--font-heading);\n  font-weight: 600;\n  font-size: 2.6rem;\n  line-height: 1.1;\n  margin: 0 0 0.25rem;\n}\n\n/* ---- Host game: all-play (Group Think / Drawn Together) ---- */\n\n.allPlay {\n  margin-top: 19rem;\n  text-align: center;\n}\n\n.allPlay .teamTitle {\n  margin-bottom: 0.75rem;\n}\n\n.allPlay .optionList {\n  gap: 0.5rem;\n}\n\n.allPlay .radiobtn label {\n  min-height: 3.2rem;\n  padding: 0.45rem 0.7rem;\n}\n\n.allPlayOverlay {\n  /* Sits in the same grid cell as the team panels, so it stacks on top of\n     them while still contributing its height to the card. */\n  position: relative;\n  align-self: start;\n  justify-self: center;\n  margin: 1.25rem 0 1.5rem;\n  padding: 1.25rem 1.5rem 1.5rem;\n  text-align: center;\n  width: 88%;\n  background-color: var(--white);\n  border-radius: var(--card-radius);\n  box-shadow: 0 10px 30px rgba(14, 36, 99, 0.25);\n  box-sizing: border-box;\n  z-index: 3;\n  animation: overlaySlideIn 0.55s var(--bounce-effect) both;\n}\n\n/* Drawn Together has no underlay player lists, so sit the card in the\n   middle of the split instead of leaving a big empty band below it. */\n.allPlayOverlay.drawnTogether {\n  align-self: center;\n}\n\n/* Waiting view: fill the split and spread the prompt / player list apart. */\n.allPlayOverlay.drawnTogether:has(.drawerStatusList) {\n  min-height: calc(var(--content-height) - 4rem);\n  display: flex;\n  flex-direction: column;\n  justify-content: space-between;\n  gap: 1.35rem;\n  padding: 2.75rem 2.5rem 2.5rem;\n}\n\n.allPlayOverlay.drawnTogether:has(.drawerStatusList) .moveTop,\n.allPlayOverlay.drawnTogether:has(.drawerStatusList) .moveHeading,\n.allPlayOverlay.drawnTogether:has(.drawerStatusList) .drawerStatusList,\n.allPlayOverlay.drawnTogether:has(.drawerStatusList) .moveFooter {\n  margin: 0;\n}\n\n.allPlayOverlay.drawnTogether:has(.drawerStatusList) .moveKicker {\n  margin: 0;\n}\n\n.allPlayOverlay.drawnTogether:has(.drawerStatusList) .moveQuestion {\n  margin: 0.7rem 0 0;\n}\n\n@keyframes overlaySlideIn {\n  from {\n    opacity: 0;\n    transform: translateY(-45%);\n  }\n  to {\n    opacity: 1;\n    transform: translateY(0);\n  }\n}\n\n.allPlayOverlay .moveQuestion {\n  margin-bottom: 0.5rem;\n}\n\n.allPlayOverlay > .timer {\n  position: absolute;\n  top: 1rem;\n  right: 1.25rem;\n  z-index: 2;\n}\n\n/* ---- Marquee content: summaries (pie lives in shared/pie.css, team picking in marquees/team-picker.css) ---- */\n\n.promptSummary {\n  color: var(--ink);\n  font-size: 1.5rem;\n  margin-bottom: 1.5rem;\n}\n\n.teamSummary {\n  display: flex;\n  margin-bottom: 1rem;\n  gap: 0.75rem;\n}\n\n.answerSummary {\n  color: var(--ink);\n  font-size: 3rem;\n}\n\n.actualAnswer {\n  color: var(--ink);\n  font-size: 6rem;\n  padding: 1rem 1rem 0;\n}\n\n.endMoveSummary {\n  flex: 1 1 50%;\n  font-size: 1.5rem;\n  color: var(--ink);\n  padding: 0.75rem 1rem;\n  border-radius: var(--border-radius);\n  min-width: 0;\n}\n\n.endMoveSummary.team1 {\n  background-color: var(--team1-panel);\n}\n\n.endMoveSummary.team2 {\n  background-color: var(--team2-panel);\n}\n\n.endMoveSummary h3,\n.endMoveSummary p {\n  margin: 0 0 0.5rem;\n  font-size: 1.6rem;\n}\n\n.summaryRow {\n  display: flex;\n  margin: 0.4rem 0;\n  font-size: 1.5rem;\n  font-family: var(--font-body);\n}\n\n.summaryRow > span {\n  height: 2rem;\n  line-height: 2rem;\n}\n\n.summaryRow :first-child {\n  flex: 1 1 70%;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n  padding: 0 0.4rem;\n  text-align: left;\n  font-family: var(--font-heading);\n  font-weight: 600;\n}\n\n.summaryRow :last-child {\n  flex: 0 0 30%;\n}\n\n.congratsSummary {\n  text-align: center;\n  display: flex;\n  align-items: center;\n  font-size: 2.6rem;\n}\n\n.congratsSummary b {\n  font-weight: 600;\n}\n\n/* ---- Drawn Together: compact player layout so the canvas gets the screen. ---- */\n\n.roomContainer.noHeader .roomHeader,\n.roomContainer.noHeader .headerAccent {\n  display: none;\n}\n\n.playerRoom.drawing {\n  padding: 0.5rem;\n  box-sizing: border-box;\n}\n\n.playerRoom.drawing .drawingInstructions {\n  font-size: 0.95rem;\n  line-height: 1.25rem;\n  margin: 0 0 0.4rem;\n  text-align: left;\n}\n\n.playerRoom.drawing .drawingStatus {\n  font-size: 0.85rem;\n  line-height: 1.1rem;\n  margin: 0 0 0.4rem;\n}\n\n.playerRoom.drawing button {\n  height: 2.6rem;\n  padding: 0 1rem;\n  font-size: 1.05rem;\n  margin: 0.3rem 0 0;\n}\n\n.posterPicker {\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(9rem, 1fr));\n  gap: 0.5rem;\n  margin: 0.3rem 0;\n}\n\n/* The drawer's locked-in poster, shown on its own while the round proceeds. */\n.chosenPoster {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  margin: 0.3rem auto;\n}\n\n.chosenPoster img {\n  display: block;\n  max-width: 100%;\n  max-height: calc(100dvh - 10rem);\n  aspect-ratio: 2 / 3;\n  object-fit: contain;\n  border-radius: 10px;\n}\n\n.chosenPoster figcaption {\n  font-size: 0.75rem;\n  line-height: 0.95rem;\n  margin-top: 0.3rem;\n  color: var(--ink-soft);\n}\n\n.posterPicker .poster {\n  border: 3px solid transparent;\n  border-radius: 12px;\n  padding: 3px;\n  cursor: pointer;\n  text-align: center;\n  background: var(--white);\n  box-shadow: var(--shadow-card);\n  -webkit-tap-highlight-color: transparent;\n}\n\n.posterPicker .poster.chosen {\n  border-color: var(--navy);\n}\n\n.posterPicker .poster img {\n  display: block;\n  width: 100%;\n  aspect-ratio: 2 / 3;\n  object-fit: cover;\n  border-radius: 8px;\n}\n\n.posterPicker .posterLabel {\n  display: block;\n  font-size: 0.75rem;\n  line-height: 0.95rem;\n  margin: 0.3rem 0 0.15rem;\n  color: var(--ink-soft);\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
